/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessResponse } from '../models/SuccessResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BillingTestService {

    /**
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static cleanAbo(): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/clean-abo',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static sampleAboByVoucher(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aboByVoucher',
        });
    }

    /**
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static sampleAboByStripe(): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aboByStripe',
        });
    }

    /**
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static sampleAboByBraintree(): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aboByBraintree',
        });
    }

    /**
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static sampleByUpgradeCourse(): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/upgradeByCourse',
        });
    }

    /**
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static missingPaymentAboNearEnd(): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/missingPaymentAboNearEnd',
        });
    }

}
